export const keyTranslator = (key) => {
  switch (key) {
    case "en-US":
      return "bef90ee3-972c-4596-9eaf-77c8f75f029a";
    case "zh-CN":
      return "fc17709f-9d82-40c4-9fa8-82107eb2b856";
    case "zh":
      return "fc17709f-9d82-40c4-9fa8-82107eb2b856";
    case "TW":
      return "0924e774-2e86-411c-af99-862ba02af52e";
    case "HI":
      return "5d4c567a-8f00-4ed5-b31b-bee124e01e84";
    case "th":
      return "75d3d3a1-186f-46a0-89d6-e62eab8c5461";
    case "vi-VN":
      return "b9012572-8d3e-4e4a-9ace-f65c8937f7e1";
    case "vi":
      return "b9012572-8d3e-4e4a-9ace-f65c8937f7e1";
    case "KR":
      return "9c39ffd4-96aa-42e9-bc2b-64edb62d3d9b";
    case "tl-PH":
      return "78b54ac6-6bc0-4f35-b6cf-9fd7c0bcb3d2";
    case "tl":
      return "78b54ac6-6bc0-4f35-b6cf-9fd7c0bcb3d2";
    case "es-ES":
      return "3a5854b9-92a5-475d-ad67-663396c5de7f";
    case "es":
      return "3a5854b9-92a5-475d-ad67-663396c5de7f";
    case "ja-JP":
      return "bcc58384-5430-41fa-b548-9e2eaff629ed";
    case "id-IN":
      return "639ba9b8-4479-4738-bb48-fa8827ebe419";
    case "id-ID":
      return "639ba9b8-4479-4738-bb48-fa8827ebe419";
    case "ar-AE":
      return "49dc7e73-315b-4c3f-9591-2f6d7c8bf3c6";
    default:
      return "bef90ee3-972c-4596-9eaf-77c8f75f029a";
  }
};
